import { useRef } from 'react';
import constate from 'constate';

import { useAppDispatch } from 'store/store-hooks';
import { EnumDragger, setDragger } from './app.slice';

type Event = PointerEvent | React.PointerEvent;

const useDraggerProvider = () => {
  const isDragging = useRef(false);
  const dispatch = useAppDispatch();

  const dragger = (elem: React.RefObject<HTMLDivElement>, src: EnumDragger) => ({
    start: (event: Event, cb: (event: PointerEvent | React.PointerEvent) => void) => {
      if (!elem.current) return;
      dispatch(setDragger(src));
      cb(event);
      elem.current.setPointerCapture(event.pointerId);
      elem.current.onpointermove = (event: PointerEvent) => {
        // [!] the sequence is important for detecting the very first onMouseMove event
        isDragging.current = true;
        cb(event);
      };
    },
    end: (event: Event, cb?: () => void) => {
      if (!elem.current) return;
      dispatch(setDragger(null));
      elem.current.releasePointerCapture(event.pointerId);
      elem.current.onpointermove = null;
      isDragging.current = false;
      if (cb) cb();
    },
  });

  return { dragger, isDragging };
};

export const [DraggerProvider, useDraggerContext] = constate(useDraggerProvider);
